module.exports = __webpack_public_path__ + "static/media/Negocie.3a6069af.svg";